export default "__VITE_ASSET__08aafaa9__"